import { useLayoutEffect, useState } from "react";

import { Button } from "src/components-v2";

import { getTranslationManually } from "src/helpers/locale";
import { createSentryReport, SentryDomains } from "src/helpers/sentry";
import { sendSlackErrorReport } from "src/helpers/slack";
import { getWithExpiry, setWithExpiry } from "./utils";

const crashSentry = createSentryReport(SentryDomains.CRASH);

export default function ErrorFallback({ error }: { error?: { message?: string } }) {
  const [showFallbackPage, setShowFallbackPage] = useState(true);

  useLayoutEffect(() => {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    // Chunk is missing/not found. Mostlikely because of a new release.
    if (error?.message && chunkFailedMessage.test(error.message)) {
      const CHUNK_FAILED_STORAGE_KEY = "isReloaded";
      const isAlreadyReloaded = getWithExpiry(CHUNK_FAILED_STORAGE_KEY);

      if (!isAlreadyReloaded) {
        // First failure after a release is expected; auto-reload usually fixes it.
        setShowFallbackPage(false);
        setWithExpiry(CHUNK_FAILED_STORAGE_KEY, true, 60000);
        window.location.reload();
      } else {
        // Chunk still failing after a reload — this one needs a human.
        crashSentry.captureException(error);
        sendSlackErrorReport({ error, source: window.location.href });
      }
    } else {
      // Send crash error to sentry
      crashSentry.captureException(error);

      // Notify the team via Slack webhook
      sendSlackErrorReport({ error, source: window.location.href });
    }
  }, [error]);

  if (showFallbackPage) {
    return (
      <div className="u-w-screen u-h-screen u-flex u-justify-center u-items-center u-p-6">
        <div>
          <h3 className="u-mb-2 u-text-2xl u-font-bold u-text-black-bekko u-max-w-xxs sm:u-max-w-none">
            {getTranslationManually("Maaf, terjadi kesalahan :(", "Sorry! Something went wrong :(")}
          </h3>
          <p className="u-text-lg u-mb-2 u-max-w-xxs sm:u-max-w-none">
            {getTranslationManually(
              "Jangan khawatir, Anda bisa coba muat ulang halaman ini.",
              "Don't worry, you can try to reload this page."
            )}
          </p>
          <Button onClick={() => window.location.reload()} variant="secondary" className="u-mb-12 u-normal-case">
            {getTranslationManually("Muat ulang", "Reload page")}
          </Button>
          <p className="u-text-lg u-mb-2">
            {getTranslationManually(
              "Jika masih bermasalah, hubungi Flip di ",
              "If that doesn't work, please reach us at "
            )}
            <a className="u-text-lg" href="mailto:support@flip.id">
              support@flip.id
            </a>
            .
          </p>
        </div>
      </div>
    );
  }

  return <></>;
}
